import React from "react";
import { Typography } from "@mui/material";

export default function Favorites() {
  return (
    <div>
      <Typography variant="h4">Favorites</Typography>
      <Typography>Feature coming soon...</Typography>
    </div>
  );
}
